/* React hooks */
import { useContext, useDebugValue } from "react";
/* Contexts */
import AuthContext from '../context/AuthProvider';


export default function useAuth() {
    const { auth } = useContext(AuthContext);
    useDebugValue( auth, auth => auth?.username ? "Logged in" : "Logged out" )
    return useContext(AuthContext)
};